var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-btn',_vm._g({staticClass:"mx-0 px-0",attrs:{"icon":"","loading":_vm.loading},on:{"click":_vm.openCollector}},on),[_c('v-icon',{class:{ throbGlow: _vm.animate }},[_vm._v("mdi-bug")])],1)]}}])},[_c('span',[_vm._v("Report a Bug")])])
}
var staticRenderFns = []

export { render, staticRenderFns }